import { useCallback } from 'react';
import { Entity, usePost, UsePostParams } from '../../../../api';
import { LOCAL_ACCOUNTS_BASE_URL } from '../consts';

export interface AdEntityGuidPayload {
    adEntityGuid: Entity['guid'];
}

export type BindLocalAccountPayload = AdEntityGuidPayload;

export type BindLocalAccountResponse = AdEntityGuidPayload & {
    boundUsersCount: number;
    limitExceeded: boolean;
};
export type BindLocalAccountError = unknown;

export type UseBindLocalAccountParams = UsePostParams<
    BindLocalAccountPayload,
    BindLocalAccountResponse,
    BindLocalAccountError
>;

export const useBindLocalAccount = (params: UseBindLocalAccountParams = {}) => {
    const { post, ...rest } = usePost<BindLocalAccountPayload, BindLocalAccountResponse, BindLocalAccountError>(params);

    const bindLocalAccount = useCallback(
        (localAccountGuid: string, entity: Entity) =>
            post(`${LOCAL_ACCOUNTS_BASE_URL}/${localAccountGuid}/bind`, {
                adEntityGuid: entity.guid
            }),
        [post]
    );

    return {
        ...rest,
        bindLocalAccount
    };
};
